<div class="uk-container">
  <div class="sidebar-network-status">
    <app-network-status></app-network-status>
  </div>

  <div class="activa-logo">
    <img src="./assets/img/static/svg-activa.svg" alt="Activa logo" />
  </div>

  <nav class="sidebar-nav">
    <div class="menu" *ngIf="hasManagerVisualizePolicePermission()">
      <button [routerLink]="['/welcome/menu/bancassurance/responsable-policy-management']" routerLinkActive="active"
        class="uk-width-1-1">
        <img class="sidebar-icon" src="assets/img/static/briefcase.svg" width="24" height="24"
          style="width:24px;height:24px;" uk-svg="stroke-animation: true" />
        <span>Gestion des polices</span>
      </button>
    </div>

    <div class="menu" *ngIf="hasBatchTransfertPermission()">
      <button [routerLink]="['/welcome/menu/bancassurance/responsable-virements']" routerLinkActive="active"
        class="uk-width-1-1">
        <img class="sidebar-icon" src="assets/img/static/budget.svg" width="24" height="24"
          style="width:24px;height:24px;" uk-svg="stroke-animation: true" />
        <span>Lots de transfert</span>
      </button>
    </div>

    <div class="menu" *ngIf="hasCreatePolicePermission()">
      <button [routerLink]="['/welcome/menu/bancassurance/bancassurance-services/service-client/police-form']"
        routerLinkActive="active" class="uk-width-1-1">
        <img class="sidebar-icon" src="assets/img/static/receipt.svg" width="24" height="24"
          style="width:24px;height:24px;" uk-svg="stroke-animation: true" />
        <span>Nouvelle Adhésion</span>
      </button>
    </div>

    <div class="menu" *ngIf="hasReadOnlyCommissionPermission()">
      <button [routerLink]="['/welcome/menu/bancassurance/responsable-commissions']" routerLinkActive="active"
        class="uk-width-1-1">
        <img class="sidebar-icon" src="assets/img/static/pension.svg" width="24" height="24"
          style="width:24px;height:24px;" uk-svg="stroke-animation: true" />
        <span>Commissions</span>
      </button>
    </div>

    <div class="menu" *ngIf="hasCreateClaimsPermission()">
      <button [routerLink]="['/welcome/menu/bancassurance/bancassurance-services/claim/claim-form']"
        routerLinkActive="active" class="uk-width-1-1">
        <img class="sidebar-icon" src="assets/img/static/caution.svg" width="24" height="24"
          style="width:24px;height:24px;" uk-svg="stroke-animation: true" />
        <span>Nouveau Sinistre</span>
      </button>
    </div>

    <div class="menu" *ngIf="hasManagerVisualizeclaimsPermission()">
      <button [routerLink]="['/welcome/menu/bancassurance/responsable-sinisters']" routerLinkActive="active"
        class="uk-width-1-1">
        <img class="sidebar-icon" src="assets/img/static/risk.svg" width="24" height="24"
          style="width:24px;height:24px;" uk-svg="stroke-animation: true" />
        <span>Gestion des Sinistres</span>
      </button>
    </div>

    <div class="menu" *ngIf="hasReadOnlyCoEnssurancePermission()">
      <button [routerLink]="['/welcome/menu/bancassurance/responsable-coassurance']" routerLinkActive="active"
        class="uk-width-1-1">
        <img class="sidebar-icon" src="assets/img/static/shield.svg" width="24" height="24"
          style="width:24px;height:24px;" uk-svg="stroke-animation: true" />
        <span>Coassurance</span>
      </button>
    </div>

  <div class="menu">
    <button (click)="goToHome()" class="uk-width-1-1">
      <svg class="sidebar-icon" width="24" height="24" viewBox="0 0 24 24" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <rect x="3" y="3" width="7" height="9" stroke="currentColor" stroke-width="2" fill="none"></rect>
        <rect x="14" y="3" width="7" height="5" stroke="currentColor" stroke-width="2" fill="none"></rect>
        <rect x="14" y="12" width="7" height="9" stroke="currentColor" stroke-width="2" fill="none"></rect>
        <rect x="3" y="13" width="7" height="5" stroke="currentColor" stroke-width="2" fill="none"></rect>
      </svg>
      <span>Dashboard</span>
    </button>
  </div>
  </nav>



</div>
